<template>
	<!-- 加载遮罩层（防穿透核心） -->
	<div class="rc-loading-mask" catchtouchmove="ture" v-show="visible">
		<!-- 加载容器：动画 + 文案 -->
		<div class="rc-loading-container" catchtouchmove="ture">
			<!-- 加载动画 -->
			<div class="rc-loading-spinner">
				<div class="rc-loading-circle"></div>
			</div>
			<!-- 加载文案（新增：渲染 text 变量） -->
			<div class="rc-loading-text" v-if="text">{{ text }}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "RCLoading",
		data() {
			return {
				visible: false, // 显示/隐藏状态
				text: "", // 新增：定义 text 变量，存储加载文案
				// timeoutTimer: null, // 超时定时器（可选）
			};
		},
		methods: {
			// 显示 Loading（传自定义文案）
			show(text = "加载中...") {
				this.visible = true;
				this.text = text; // 赋值到 data 中的 text
				// 防滚动穿透
				document.body.style.overflow = "hidden";
				document.body.style.touchAction = "none";

				// // 可选：超时自动关闭（10秒）
				// clearTimeout(this.timeoutTimer);
				// this.timeoutTimer = setTimeout(() => {
				//   this.hide();
				// }, 10000);
			},
			// 隐藏 Loading
			hide() {
				this.visible = false;
				this.text = ""; // 清空文案
				// 恢复滚动
				document.body.style.overflow = "";
				document.body.style.touchAction = "";

				// // 清除超时定时器
				// clearTimeout(this.timeoutTimer);
			},
		},
	};
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;

	/* 遮罩层：全屏覆盖 + 防点击穿透 */
	.rc-loading-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		padding-bottom: 20vh;
		// background: rgba(0, 0, 0, .05);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 99999;
		pointer-events: auto;
	}

	/* 加载容器：动画 + 文案垂直排列 */
	.rc-loading-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 24*@vm_base;
		/* 动画和文案的间距 */
		/* width: 150*@vm_base; */
		padding: 40*@vm_base 60*@vm_base;
		border-radius: 16*@vm_base;
		background: rgba(0, 0, 0, 0.5);
		/* border: 1*@vm_base solid red; */
	}

	/* 加载动画容器 */
	.rc-loading-spinner {
		width: 100*@vm_base;
		height: 100*@vm_base;
		position: relative;
	}

	/* 旋转动画 */
	.rc-loading-circle {
		width: 100%;
		height: 100%;
		border: 8*@vm_base solid rgba(247, 127, 40, .3);
		border-top: 8*@vm_base solid #F77F28;
		border-radius: 50%;
		animation: rc-loading-rotate 1s linear infinite;
	}

	@keyframes rc-loading-rotate {
		0% {
			transform: rotate(0deg);
		}

		50% {
			transform: rotate(90deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}

	/* 加载文案样式 */
	.rc-loading-text {
		font-size: 28*@vm_base;
		color: #fff;
		font-weight: lighter;
		/* text-shadow: 0 0 2*@vm_base rgba(0, 255, 255, 1); */
		/* 增加文案可读性 */
	}
</style>


// WEBPACK FOOTER //
// src/common/RCLoading/RCLoading.vue